import React from 'react';
import UserGroupIcon from '@heroicons/react/outline/UserGroupIcon.js';
import { BlockType } from '../../types/index.js';
import { SpaceMemberListBlock as Component } from './Block.js';
export const RegisteredSpaceMemberListBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'WhySpaceMemberList',
        Component,
        config: {
            type: BlockType.Block,
            displayName: $t({
                id: 'Blocks.SpaceMemberList.DisplayName',
                defaultMessage: '{SPACE_CC} Member List',
            }),
            deprecated: true,
            Icon: React.createElement(UserGroupIcon, null),
        },
    };
};
//# sourceMappingURL=registered.js.map